import { css } from '@emotion/css';
import { OrderStatusLabel } from 'src/models';
import { Display, Font, FontWeight } from 'src/styles';
import { getOrderStatusTagColor } from 'src/utils';

export const tag = (transfer: OrderStatusLabel) => {
  const schema = getOrderStatusTagColor(transfer);

  return css`
    ${Font.lg}
    ${Display.flex}
    ${FontWeight.semibold}
    width: fit-content;
    padding: 0.25rem 0.5rem;
    border: 0.0625rem solid ${schema.background};
    border-radius: 0.5rem;
    color: ${schema.color};
    background-color: ${schema.background};
    height: 1.5rem;
  `;
};
